<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M13 19.5V24l-6-4.5v-3.09l-7-7V7a3 3 0 0 1 2-2.82v4.4l7 7v2.92l2 1.5v-2zm4-7.09 7-7V3a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v2.41l7 7v3.09l6 4.5zm-4-.82-7-7V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1.59l-7 7V16l-2-1.5z"/></svg>
</template>
